import {
  getCardBalancesOfEmployeesToDelete,
  getPayrollAdjustmentsOfEmployeesToDelete,
  getPendingPaymentsByEmployees,
  getBenefitBags,
} from "infrastructure/repository/employees-repository";
import qs from "qs";
import { displayDeleteMultipleEmployeesModal } from "./displays/display-delete-employees-modal";
import { findCompanyDetail } from "../../infrastructure/repository/company-repository";

export default async function reviewEmployeesToDelete({
  employees,
  currentStep = 0,
  adjustmentsPagination = { pageSize: 10, pageNumber: 1 },
  target,
}) {
  let resultantEmployees = employees;

  if (employees.length === 0) {
    resultantEmployees = qs.parse(
      window.location.search.replace("?", "")
    )?.employees;
    if (!Array.isArray(resultantEmployees)) {
      resultantEmployees = [resultantEmployees];
    }
  }
  const { data: companyDetails } = await findCompanyDetail();
  const companyId = companyDetails.id;

  let data;

  displayDeleteMultipleEmployeesModal(
    {
      currentStep,
      isLoading: true,
      employees: [],
    },
    target
  );

  if (currentStep === 0) {
    const { data: adjustments } =
      await getPayrollAdjustmentsOfEmployeesToDelete({
        companyId,
        employees: resultantEmployees,
        pageSize: adjustmentsPagination?.pageSize,
        pageNumber: adjustmentsPagination?.pageNumber,
      });
    data = { adjustments };
  }

  if (currentStep === 1) {
    const { data: adjustments } =
      await getPayrollAdjustmentsOfEmployeesToDelete({
        companyId,
        employees: resultantEmployees,
        pageSize: adjustmentsPagination?.pageSize,
        pageNumber: adjustmentsPagination?.pageNumber,
      });

    const { data: benefitBags } = await getBenefitBags({
      companyId,
      employeeIds: resultantEmployees,
    });

    const employeeWithBag = adjustments.map(
      ({ employee: { id, legalId, name, surname, activeSinceTimestamp } }) => {
        const benefitBag = benefitBags?.content?.[id]?.[0];

        return {
          id,
          legalId,
          name: `${name} ${surname}`,
          activeSinceTimestamp,
          benefitBag,
        };
      }
    );

    data = employeeWithBag;
  }

  if (currentStep === 2) {
    const { data: pendingPayments } = await getPendingPaymentsByEmployees({
      companyId,
      employees: resultantEmployees,
    });

    let _pendingPayments = Object.values(pendingPayments?.content);

    _pendingPayments = _pendingPayments.map((item) => {
      const { employee } = item?.[0];

      const benefits = item.reduce((acc, value) => {
        const { category } = value;
        return { ...acc, [category]: [...(acc[category] || []), value] };
      }, {});

      return {
        employee,
        benefits,
      };
    });

    data = {
      pendingPayments: _pendingPayments,
    };
  }
  if (currentStep === 3) {
    const { data: cardBalances } = await getCardBalancesOfEmployeesToDelete({
      companyId,
      employees: resultantEmployees,
    });
    data = cardBalances;
  }

  displayDeleteMultipleEmployeesModal(
    {
      employees: resultantEmployees,
      currentStep,
      data,
      adjustmentsPagination: adjustmentsPagination || {
        pageNumber: 0,
        pageSize: 10,
      },
      country: companyDetails.countryISO2Code,
    },
    target
  );
}
